import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { AppLoader } from '@sternum/web/components';
import { appStorage } from '@sternum/web/services/appStorage';

import { useRedirectToDefaultPath } from '../../hooks';

export function SsoLoginCallback() {
  const [searchParams] = useSearchParams();
  const { redirectToDefaultPath } = useRedirectToDefaultPath();

  const token = searchParams.get('token');
  const clientId = searchParams.get('clientId');

  useEffect(() => {
    if (!clientId || !token) return;

    appStorage.setToken(token);
    redirectToDefaultPath(clientId).then();
  }, [token, clientId, redirectToDefaultPath]);

  if (!clientId) {
    throw new Error(`"clientId" param is not present in url`);
  }

  if (!token) {
    throw new Error(`"token" param is not present in url`);
  }

  return <AppLoader />;
}
